import { Record, RecordMap } from '../types'

/** Normalize list records by id. Uses nullish id checks so numeric `0` is kept (truthy checks drop it). */
export const recordsToRecordMap = <RecordType extends Record = Record>(
  records: RecordType[]
): RecordMap<RecordType> => {
  return records.reduce((acc, record) => {
    if (!record || record.id === undefined || record.id === null) return acc
    acc[record.id] = record
    return acc
  }, {} as RecordMap<RecordType>)
}
